"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OTHER = exports.UNION_DUES = exports.GARNISHMENTS = exports.DOMESTIC_SUPPORT_OBLIGATIONS = exports.CHILD_SUPPORT = exports.ALIMONY = exports.INSURANCE = exports.RETIREMENT_FUND_LOAN_REPAYMENT = exports.VOLUNTARY_RETIREMENT_CONTRIBUTIONS = exports.MANDATORY_RETIREMENT_CONTRIBUTIONS = exports.SOCIAL_SECURITY = exports.MEDICARE = exports.LOCAL_TAXES = exports.STATE_TAXES = exports.FEDERAL_TAXES = void 0;
exports.FEDERAL_TAXES = "federalTaxes";
exports.STATE_TAXES = "stateTaxes";
exports.LOCAL_TAXES = "localTaxes";
exports.MEDICARE = "medicare";
exports.SOCIAL_SECURITY = "socialSecurity";
exports.MANDATORY_RETIREMENT_CONTRIBUTIONS = "mandatoryRetirementContributions";
exports.VOLUNTARY_RETIREMENT_CONTRIBUTIONS = "voluntaryRetirementContributions";
exports.RETIREMENT_FUND_LOAN_REPAYMENT = "retirementFundLoanRepayment";
exports.INSURANCE = "insurance";
exports.ALIMONY = "alimony";
exports.CHILD_SUPPORT = "childSupport";
exports.DOMESTIC_SUPPORT_OBLIGATIONS = "domesticSupportObligations";
exports.GARNISHMENTS = "garnishments";
exports.UNION_DUES = "unionDues";
exports.OTHER = "other";